import React, { Fragment, useState, useMemo, useEffect } from "react";
import MainWrapper from "../../../MainWrapper";
import Loader from "../.././../layouts/Loader";
import { Link, useNavigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back } from 'react-icons-kit/md';
import CustomButton from "../../../elements/CustomButton";
import Table from "./KitTable";
import Model from "./AddEdit";
import {
  PRODUCT_TYPE_REQUEST,
  GET_SUB_PRODUCT_REQUEST,
  WALLBASE_ID_DB,
  INSTALLATION_ACCESSORIES_ID_DB,
  TRANSITION_ID_DB,
  GET_SUB_PRODUCT_MATERIAL_REQUEST
} from "../../../../_utils/constants/ProductCatalog";
import {
  STORE_INFO_REQUEST,
} from "../../../../_utils/constants/admin/StoreInfo";
import {
  MATERIAL_ADDONS_REQUEST,
  LABOR_ADDONS_REQUEST,
  KIT_CREATE,
  KIT_REQUEST,
  KIT_EDIT_REQUEST,
  KIT_DELETE,
  KIT_UPDATE_REQUEST,
  KIT_CREATED_REQUEST
} from "../../../../_utils/constants/Kits";
import {
  LABOR_CATEGORY_REQUEST
} from "../../../../_utils/constants/Labor";
import { connect } from "react-redux";
import { toast } from 'react-toastify';

const Kits = ({
  auth: { auth, isAuthenticated },
  ProductType,
  StoreInfo: { storeInfo },
  kits: {
    materialAddons,
    laborAddons,
    isCreated,
    kits,
    kit,
    isEditedList,
    isUpdated,
    isDeleted,
    createdMessage,
    isLoading
  },
  fetchProductType,
  fetchStoreInfo,
  fetchMaterialAddons,
  fetchLaborAddons,
  fetchLaborCategory,
  LaborCategory: { laborCategory },
  createKit,
  fetchKit,
  deleteKit,
  fetchEditKit,
  updateKit,
  fetchEditCreated,
  ProductType: { getSubProductData, getSubProductMaterialData },
	fetchSubProductRequest,
  fetchSubProductMaterialRequest
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [deleteKitId, setDeleteKitId] = useState("");
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [validated, setValidated] = useState(false);
  // const [isUnique, setIsUnique] = useState(false);
  const [prevData, setPrevData] = useState({
    "StoreId": "",
    "ProductTypeId": "",
    "subProductTypeId": "",
    "ProductId": "",
    "KitId": "",
  })
  const [state, setState] = useState({
    "StoreId": "",
    "ProductTypeId": "",
    "ProductId": "",
    "KitId": "",
    "subProductTypeId": "",
  })
  const [materialFilter, setMaterialFilter] = useState({
    "ProductTypeId": "",
    "StoreId": "",
    "PrivateName": "",
    "Manufacturer": "",
    "Style": "",
    "Color": "",
    "subProductTypeId": "",
    "ProductId": "",
    "KitId": "",
  })
  const [materialAddOnFilter, setMaterialAddOnFilter] = useState({
    "ProductTypeId": "",
    "StoreId": "",
    "PrivateName": "",
    "Manufacturer": "",
    "Style": "",
    "Color": "",
    "subProductTypeId": "",
    "ProductId": "",
    "KitId": "",
  })
  const [laborFilter, setLaborFilter] = useState({
    "ProductTypeId": "",
    "ProductStructureIdForLabor": "",
    "StoreId": "",
    "LaborCategory": "",
    "LaborName": "",
    "subProductTypeId": "",
    "ProductId": "",
    "KitId": "",
  })
  const [kitMaterial, setKitMaterial] = useState([]);
  const [kitLabor, setKitLabor] = useState([]);
  const [editId, setEditId] = useState("");
  const [listFilter, setListFilter] = useState({
    "StoreId": 0,
    "ProductTypeId": 0,
    "ProductId": 0,
    "KitId": 0,
    "subProductTypeId": 0,
  })
  const [checkFlag, setCheckFlag] = useState(false);

  const navigate = useNavigate();

  // handle user auth
  useEffect(() => {
		if (!isAuthenticated) {
			navigate("/login")
		}
	}, [auth, isAuthenticated])

  const handleMaterialSelect = (e, id) => {
    if (!e.target.checked) {
      setKitMaterial(kitMaterial => kitMaterial.filter(d => d.ProductId !== id));
    } else {
      setKitMaterial(kitMaterial => [...kitMaterial, { ProductId: id }]);
    }
  };

  const handleLaborSelect = (e, id) => {
    if (!e.target.checked) {
      setKitLabor(kitLabor => kitLabor.filter(d => d.LaborItemId !== id));
    } else {
      setKitLabor(kitLabor => [...kitLabor, { LaborItemId: id }]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    } else {

      if (!kitMaterial.length > 0 && !kitLabor.length > 0) {
        toast.error("At least one item is required.")
      } else {
        let uniqueKitMaterial = _.uniqBy(kitMaterial, "ProductId")
        if (editId) {
          var requestData =
          {
            "data": {
              "KitId": editId,
              "StoreId": parseInt(state.StoreId),
              "ProductStructureId": parseInt(state.ProductTypeId),
              "ProductId": 0,
              "subProductStructureId": state.subProductTypeId ? parseInt(state.subProductTypeId) : 0,
              "KitMaterial": uniqueKitMaterial,
              "KitLabor": [...new Map(kitLabor.map(item => [JSON.stringify(item), item])).values()],
              "CreatedBy": auth[0].userId
            },
            "token": auth[0].token
          }
          updateKit(requestData)
        } else {
          var requestData =
          {
            "data": {
              "StoreId": parseInt(state.StoreId),
              "ProductStructureId": parseInt(state.ProductTypeId),
              "KitId": 0,
              "ProductId": 0,
              "subProductStructureId": state.subProductTypeId ? parseInt(state.subProductTypeId) : 0,
              "KitMaterial": kitMaterial,
              "KitLabor": [...new Map(kitLabor.map(item => [JSON.stringify(item), item])).values()],
              "CreatedBy": auth[0].userId
            },
            "token": auth[0].token
          }
          createKit(requestData);
        }
      }
    }
    // setCheckFlag(false)
    setValidated(true);
  }

  const reset = () => {
    setState({
      "StoreId": 0,
      "ProductTypeId": 0,
      "subProductTypeId": 0,
      "ProductId": 0,
      "KitId": 0,
    })
    setPrevData({
      "StoreId": 0,
      "ProductTypeId": 0,
      "subProductTypeId": 0,
      "ProductId": 0,
      "KitId": 0,
    })
    setKitMaterial([])
    setKitLabor([])
    setMaterialFilter({
      "ProductTypeId": "",
      "StoreId": "",
      "PrivateName": "",
      "Manufacturer": "",
      "Style": "",
      "Color": "",
      "subProductTypeId": "",
      "ProductId": "",
      "KitId": "",
    })
    setLaborFilter({
      "ProductTypeId": "",
      "ProductStructureIdForLabor": "",
      "StoreId": "",
      "LaborCategory": "",
      "LaborName": "",
      "subProductTypeId": "",
      "ProductId": "",
      "KitId": "",
    })
    setListFilter({
      "StoreId": 0,
      "ProductTypeId": 0,
      "ProductId": 0,
      "subProductTypeId": 0,
      "ProductId": "",
      "KitId": "",
    })
    setEditId("");
    setValidated(false);
    setMaterialAddOnFilter({
      "ProductTypeId": "",
      "StoreId": "",
      "PrivateName": "",
      "Manufacturer": "",
      "Style": "",
      "Color": "",
      "subProductTypeId": "",
      "ProductId": "",
      "KitId": "",
    })
  }

  const handleModal = (e) => {
    e.preventDefault();
    reset();
    setIsOpen(!isOpen)
  }

  const hideModel = () => {
    setIsOpen(false)
    // setCheckFlag(false)
    reset();
  }

  const handleListChange = (e) => {
    const { id, value } = e.target;
    if(parseInt(value) === WALLBASE_ID_DB || parseInt(value) === INSTALLATION_ACCESSORIES_ID_DB || parseInt(value) === TRANSITION_ID_DB) {
			fetchSubProductRequest({
				"productStructureId": parseInt(value),
				"token": auth[0].token
			});
		}
		if(listFilter?.ProductTypeId !== parseInt(value)) {
			setListFilter(
				{
					...listFilter,
					subProductTypeId: 0,
					[id]: value ? value : 0
				}
			)	
		} else {
			setListFilter(
				{
					...listFilter,
					[id]: value ? value : 0
				}
			)
		}
  }

  const handleChange = (e) => {
    const { id, value } = e.target;
    setCheckFlag(false)
    setMaterialAddOnFilter({
      "ProductTypeId": "",
      "StoreId": "",
      "PrivateName": "",
      "Manufacturer": "",
      "Style": "",
      "Color": "",
      "subProductTypeId": ""
    })
    if(parseInt(value) === WALLBASE_ID_DB || parseInt(value) === INSTALLATION_ACCESSORIES_ID_DB || parseInt(value) === TRANSITION_ID_DB) {
			fetchSubProductRequest({
				"productStructureId": parseInt(value),
				"token": auth[0].token
			});
		}
    if(id === "ProductTypeId") {
      setState({
        ...state,
        [id]: value,
        subProductTypeId: 0
      })
      setMaterialFilter({
        ...materialFilter,
        [id]: value,
        subProductTypeId: 0
      })
      setLaborFilter({
        ...laborFilter,
        [id]: value,
        subProductTypeId: 0
      })
    } else {
      setState({
        ...state,
        [id]: value
      })
      if(id !== "subProductTypeId") {
        setMaterialFilter({
          ...materialFilter,
          [id]: value
        })
        setLaborFilter({
          ...laborFilter,
          [id]: value
        })
      } else {
        setMaterialFilter({
          ...materialFilter,
          [id]: value,
          //Commented on 29 November 2022 for sub product dependent material add on listing
          // subProductTypeId: 0
        })
        setLaborFilter({
          ...laborFilter,
          [id]: value
        })
      }
    }
    //Commented on 29 November 2022 for sub product dependent labor add on listing
    // setLaborFilter({
    //   ...laborFilter,
    //   [id]: value
    // })
    setKitMaterial([]);
    setKitLabor([]);
  }
  // use effect function called after api success
  useMemo(() => {
    if (isAuthenticated) {
      if (isCreated === true) {
        toast.success("Kit created successfully.");
        hideModel();
      }
      if (isDeleted === true) {
        toast.success("Kit deleted successfully.");
        //changeReducerState();
      }
  
      if (isUpdated === true) {
        toast.success("Kit updated successfully.")
        // changeReducerState();
        hideModel();
      }
      fetchKit(auth[0].token, listFilter)
    }
  }, [isCreated, isDeleted, isUpdated]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchProductType(auth[0].token);
    }
  }, [auth, isAuthenticated]);
  useEffect(() => {
    if (isAuthenticated) {
      fetchStoreInfo(auth[0].token);
    }
  }, [auth, isAuthenticated]);
  useEffect(() => {
    if (isAuthenticated) {
      fetchLaborCategory(auth[0].token)
    }
  }, [isAuthenticated, auth])
  useEffect(() => {
    if (isAuthenticated && !editId) {
      fetchKit(auth[0].token, listFilter)
    }
  }, [isAuthenticated, auth, listFilter])
  useEffect(() => {
    if (isAuthenticated && materialFilter.StoreId && materialFilter.ProductTypeId) {
      fetchMaterialAddons(auth[0].token, materialFilter, checkFlag);
    }
  }, [auth, isAuthenticated, materialFilter, isEditedList]);
  useEffect(() => {
    if (isAuthenticated && laborFilter.StoreId && laborFilter.ProductTypeId) {
      fetchLaborAddons(auth[0].token, laborFilter);
    }
  }, [auth, isAuthenticated, laborFilter, isEditedList]);

  const checkAlert = useMemo(() => {
    if ((parseInt(prevData.StoreId) === parseInt(state.StoreId))
      && (parseInt(prevData.ProductTypeId) === parseInt(state.ProductTypeId))) {
      if(parseInt(prevData.subProductTypeId) === parseInt(materialFilter.subProductTypeId)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }, [state, prevData])

  // use effect function called after api success
  useMemo(() => {
    if (createdMessage === 'This Kit is already created , please use the edit option to modify.' && !checkAlert) {
      toast.error("This Kit is already created , please use the edit option to modify.")
    }
  }, [createdMessage, checkAlert]);

  useMemo(() => {
    if ((isAuthenticated && state.StoreId !== 0 && !checkAlert)) {
      fetchEditCreated(auth[0].token, state, isEditedList)
    }
  }, [auth, isAuthenticated, state, checkAlert])

  // function to open confirm delete modal
  const showConfirmDeleteModal = (id) => {
    setDeleteKitId(id);
    setConfirmDeleteModal(true);
  };

  // function to close confirm delete modal
  const hideConfirmDeleteModal = () => {
    setDeleteKitId('');
    setConfirmDeleteModal(false);
  };
  // function called for delete age demographic delete api
  const handleConfirmDeleteSubmit = () => {
    deleteKit({
      "KitId": deleteKitId,
      "token": auth[0].token
    });
    hideConfirmDeleteModal();
  }
  const handleFilter = (e) => {
    const { id, value } = e.target;
    setMaterialFilter({
      ...materialFilter,
      [id]: value
    })
    setLaborFilter({
      ...laborFilter,
      [id]: value
    })
  }
  const handleMaterialFilterChange = (e) => {
    const { id, value } = e.target;
    setCheckFlag(true)
    // setCheckFlag(false)
    setMaterialFilter({
      ...materialFilter,
      [id]: value
    })

    setMaterialAddOnFilter({
      ...materialAddOnFilter,
      [id]: value
    })

    if (id === "ProductTypeId" && !value && state.ProductTypeId) {
      setCheckFlag(false)
      setMaterialFilter({
        ...materialFilter,
        [id]: state.ProductTypeId,
        // subProductTypeId:0
      })
    }
    //28 Nov 2022 added new condition to reset subProductTypeId when ProductTypeId changed
    if (id === "ProductTypeId" && parseInt(value) > 0 && state.ProductTypeId !== value) {
      setMaterialFilter({
        ...materialFilter,
        [id]: value,
        // subProductTypeId:0
      })
    }
    if (id === "ProductTypeId" && parseInt(value) > 0 && state.ProductTypeId === value) {
      setMaterialFilter({
        ...materialFilter,
        [id]: value,
        // subProductTypeId:0
      })
    }
    if(parseInt(value) === WALLBASE_ID_DB || parseInt(value) === INSTALLATION_ACCESSORIES_ID_DB || parseInt(value) === TRANSITION_ID_DB) {
			fetchSubProductMaterialRequest({
				"productStructureId": parseInt(value),
				"token": auth[0].token
			});
		}

    if (id === "subProductTypeId") {
      setMaterialFilter({
        ...materialFilter,
        [id]: value
      })
    }
    if ((id === "PrivateName" || id === "Manufacturer" || id === "Style" || id === "Color")) {
      if (materialAddOnFilter.ProductTypeId) {
        setCheckFlag(true)
      } else {
        setCheckFlag(false)
      }
    }
  }
  const handleLaborFilterChange = (e) => {
    const { id, value } = e.target;
    setLaborFilter({
      ...laborFilter,
      [id]: value
    })
    if (id === "ProductTypeId" && !value && state.ProductTypeId) {
      // setCheckFlag(false)
      setLaborFilter({
        ...laborFilter,
        [id]: state.ProductTypeId,
        subProductTypeId:0
      })
    }
    if (id === "ProductTypeId" && parseInt(value) > 0 && state.ProductTypeId !== value) {
      setLaborFilter({
        ...laborFilter,
        [id]: state.ProductTypeId,
        subProductTypeId:0
      })
    }
  }
  const productStructure = useMemo(() => {
    if (ProductType) {
      //previous functionality
      // var defaultV = ProductType.valueList.filter((p) => p.isDefault === true);
      let defaultV = ProductType.valueList;
      return defaultV.map(v => ({ label: v.productStructure, value: v.productStructureId }))
    }
  }, [ProductType])

  const otherProductStructure = useMemo(() => {
    if (ProductType) {
      //previous functionality
      var other = ProductType.valueList.filter((p) => p.isDefault !== true);
      // let other = ProductType.valueList;
      return other.map(v => ({ label: v.productStructure, value: v.productStructureId }))
    }
  }, [ProductType])

  // handle sub product structure response data
	const productSubStructure = useMemo(() => {
		if(getSubProductData) {
			return getSubProductData.map(v => ({ label: v.productStructure, value: v.productStructureId }))
		}
	}, [getSubProductData])

  // handle sub product structure response data
	const otherProductSubStructure = useMemo(() => {
		if(getSubProductMaterialData) {
			return getSubProductMaterialData.map(v => ({ label: v.productStructure, value: v.productStructureId }))
		}
	}, [getSubProductMaterialData])

  const storeList = useMemo(() => {
    if (storeInfo)
      return storeInfo.map(v => ({ label: v.storeName, value: v.storeId }))
  }, [storeInfo])
  const laborCategories = useMemo(() => {
    if (laborCategory)
      return laborCategory.map(v => ({ label: v.laborCategory, value: v.laborCategoryId }))
  }, [laborCategory])
  const mAddon = useMemo(() => materialAddons, [materialAddons])
  
  // handle material add on on selection
  useMemo(() => {
    materialAddons && materialAddons.map((material) => {
      if (material.isSelected) {
        setKitMaterial(kitMaterial => [...kitMaterial, { ProductId: material.productId }]);
      }
    })
  }, [materialAddons])

  const lAddon = useMemo(() => laborAddons, [laborAddons])

  useMemo(() => {
    laborAddons && laborAddons.map((labor) => {
      if (labor.isSelected) {
        setKitLabor(kitLabor => [...kitLabor, { LaborItemId: labor.laborItemId }]);
      }
    })
  }, [laborAddons])

  const kitList = useMemo(() => kits, [kits])
  const handleEdit = (e, data) => {
    e.preventDefault();
    if(data?.productStructureId === WALLBASE_ID_DB || data?.productStructureId === INSTALLATION_ACCESSORIES_ID_DB || data?.productStructureId === TRANSITION_ID_DB) {
			fetchSubProductRequest({
				"productStructureId": data?.productStructureId,
				"token": auth[0].token
			});
		}
    let filter = {
      "StoreId": data.storeId,
      "ProductTypeId": data.productStructureId,
      "subProductTypeId": data.subProductStructureId,
      "ProductId": 0,
      "KitId": data.kitId,
    }
    setState({
      "StoreId": data.storeId,
      "ProductTypeId": data.productStructureId,
      "subProductTypeId": data.subProductStructureId,
      "ProductId": 0,
      "KitId": data.kitId,
    })
    setPrevData({
      "StoreId": data.storeId,
      "ProductTypeId": data.productStructureId,
      "subProductTypeId": data.subProductStructureId,
      "ProductId": 0,
      "KitId": data.kitId,
    })
    setMaterialFilter({
      ...materialFilter,
      "StoreId": data.storeId,
      "ProductTypeId": data.productStructureId,
      "subProductTypeId": data.subProductStructureId,
      "ProductId": 0,
      "KitId": data.kitId,
    })
    setLaborFilter({
      ...laborFilter,
      "StoreId": data.storeId,
      "ProductTypeId": data.productStructureId,
      "ProductStructureIdForLabor": '0',
      "subProductTypeId": data.subProductStructureId,
      "ProductId": 0,
      "KitId": data.kitId,
    })
    setEditId(data.kitId);
    if (isAuthenticated && filter.StoreId !== '') {
      fetchEditKit(auth[0].token, filter)
    }
  }
  useEffect(() => {
    if (isEditedList) {

      let data = kit ? kit[0] : [];

      if (data) {
        if (data.kitMaterial) {

          setKitMaterial(data.kitMaterial.filter(labor => {
            if (labor.isSelected === true) {
              return {
                ProductId: labor.productId
              }
            }

          }).map(m => { return { "ProductId": m.productId } }))
        }
        if (data.kitLabor) {

          setKitLabor(data.kitLabor.filter(d => {
            if (d.isSelected === true) {
              return d
            }
          }).map(m => { return { "LaborItemId": m.laborItemId } }))
        }
      }

      setIsOpen(!isOpen)
    }
  }, [isEditedList])

  return (
    <Fragment>
      <MainWrapper>
        <Loader loading={false}>
          <div className="container">
            <div className="sub-header mt-5 mb-3">
              <h2>Kits</h2>
              <Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back</Link>
              <CustomButton
                handleClick={handleModal}
                variant="primary"
              >Add New Kit
              </CustomButton>
            </div>
            <Table
              productStructure={productStructure}
              storeList={storeList}
              kitList={kitList}
              handleListChange={handleListChange}
              showConfirmDeleteModal={showConfirmDeleteModal}
              hideConfirmDeleteModal={hideConfirmDeleteModal}
              handleConfirmDeleteSubmit={handleConfirmDeleteSubmit}
              confirmDeleteModal={confirmDeleteModal}
              handleEdit={handleEdit}
              productSubStructure={productSubStructure}
              listFilter={listFilter}
            />
          </div>
        </Loader>
        <Model
          isOpen={isOpen}
          size={'xl'}
          hideModel={hideModel}
          productStructure={productStructure}
          storeList={storeList}
          handleMaterialFilterChange={handleMaterialFilterChange}
          handleLaborFilterChange={handleLaborFilterChange}
          handleFilter={handleFilter}
          materialFilter={materialFilter}
          mAddon={mAddon}
          lAddon={lAddon}
          laborCategories={laborCategories}
          otherProductStructure={otherProductStructure}
          handleChange={handleChange}
          handleMaterialSelect={handleMaterialSelect}
          handleLaborSelect={handleLaborSelect}
          kitMaterial={kitMaterial}
          kitLabor={kitLabor}
          handleSubmit={handleSubmit}
          state={state}
          createdMessage={createdMessage}
          editId={editId}
          validated={validated}
          isLoading={isLoading}
          productSubStructure={productSubStructure}
          otherProductSubStructure={otherProductSubStructure}
          materialAddOnFilter={materialAddOnFilter}
        />
      </MainWrapper>
    </Fragment>
  )
}

const mapStateToProps = ({ auth, ProductType, StoreInfo, kits, LaborCategory }) => {
  return {
    auth, ProductType, StoreInfo, kits, LaborCategory
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProductType: (token) => dispatch({ type: PRODUCT_TYPE_REQUEST, token }),
    fetchStoreInfo: (token) => dispatch({ type: STORE_INFO_REQUEST, token }),
    fetchMaterialAddons: (token, data, checkFlag) => dispatch({ type: MATERIAL_ADDONS_REQUEST, token, data, checkFlag }),
    fetchLaborAddons: (token, data) => dispatch({ type: LABOR_ADDONS_REQUEST, token, data }),
    fetchLaborCategory: (token) => dispatch({ type: LABOR_CATEGORY_REQUEST, token }),
    createKit: (data) => dispatch({ type: KIT_CREATE, data }),
    fetchKit: (token, data) => dispatch({ type: KIT_REQUEST, token, data }),
    fetchEditKit: (token, data) => dispatch({ type: KIT_EDIT_REQUEST, token, data }),
    fetchEditCreated: (token, data) => dispatch({ type: KIT_CREATED_REQUEST, token, data }),
    deleteKit: (data) => dispatch({ type: KIT_DELETE, data }),
    updateKit: (data) => dispatch({ type: KIT_UPDATE_REQUEST, data }),
    fetchSubProductRequest: (data) => dispatch({ type: GET_SUB_PRODUCT_REQUEST, data }),
    fetchSubProductMaterialRequest: (data) => dispatch({ type: GET_SUB_PRODUCT_MATERIAL_REQUEST, data })
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Kits);